import { Option } from 'types'

export const CUSTOM_FORM_ENTITY_KIND_OPTIONS: Option[] = [
  {
    label: 'Centro de custo',
    value: 'COST_CENTER',
  },
  {
    label: 'Cidade',
    value: 'CITY',
  },
  {
    label: 'Estado',
    value: 'STATE',
  },
  {
    label: 'Estado civil',
    value: 'CIVIL_STATE',
  },
  {
    label: 'Grau de instrução',
    value: 'LEVEL_OF_EDUCATION',
  },
  {
    label: 'Grau de parentesco',
    value: 'DEGREES_OF_KINSHIP',
  },
  {
    label: 'Papéis',
    value: 'ROLE',
  },
  {
    label: 'Pessoa unificada',
    value: 'UNIFIED_PERSON',
  },
  {
    label: 'Posto de trabalho',
    value: 'JOBSITE',
  },
  {
    label: 'Raça',
    value: 'RACE',
  },
  {
    label: 'Salário',
    value: 'SALARY',
  },
  {
    label: 'Tipo de admissão',
    value: 'PROFESSIONAL_CONTRACT_TYPE',
  },
  {
    label: 'Unidade',
    value: 'ORGANIZATIONAL_UNIT',
  },
]
